import db from "../firebase";
import { writable } from "svelte/store";

export async function loadDocuments(Doc) {
  let data = {
    status: false,
    data: [],
  };
  try {
    await db
      .collection("service")
      .orderBy("date", "asc")
      .limit(1)
      .startAfter(Doc)
      .get()
      .then((querySnapshot) => { 
        if (querySnapshot.docs.length > 0) {
          data.querySnapshot=[querySnapshot.docs[0],querySnapshot.docs[length - 1]];
          querySnapshot.forEach((doc) => {
            data.data.push({ doc: doc.data(), id: doc.id });
          });
          
            data.status = true;
          }
      });

    
  } catch (error) {
    console.error("Error obteniendo los documentos: ", error);
  }
  return data;
}


export async function afterDocuments(Doc) {

  let data = {
    status: false,
    data: [],
  };
  try {
    await db
      .collection("service")
      .orderBy("date", "desc")
      .limit(1)
      .startAfter(Doc)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          data.querySnapshot=[querySnapshot.docs[0],querySnapshot.docs[length - 1]];
          querySnapshot.forEach((doc) => {
            data.data.push({ doc: doc.data(), id: doc.id });
          });
          
            data.status = true;
          }

      });
  } catch (error) {
    console.error("Error obteniendo los documentos: ", error);
    data.status = false;
  }

  return data;
}

export async function countDocs(collection) {

  let data = {
    status: false,
    data: 0,
  };
  try {
    await db
      .collection("service")
      .get()
      .then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) { 
            data.data= querySnapshot.docs.length          
              data.status = true;
            }
      });
  } catch (error) {
    console.error("Error obteniendo los documentos: ", error);
    data.status = false;
  }
  return data;
}


export async function readDocuments() {
  let data = {
    status: false,
    data: [],
  };
  try {
    await db
      .collection("service")
      .orderBy("date", "asc")
      .limit(1)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
        data.querySnapshot=[querySnapshot.docs[0],querySnapshot.docs[querySnapshot.docs.length - 1]];
        querySnapshot.forEach((doc) => {
          data.data.push({ doc: doc.data(), id: doc.id });
        });
        
          data.status = true;
        }
      });


  } catch (error) {
    console.error("Error obteniendo los documentos: ", error);
  }
  return data;
}


function readValue(doc) {
  let data = [];
  if (doc.length > 0) {
    doc.forEach((item) => {
      data.push(item.data());
    });
  }

  return data;
}
